<script setup>
// Consistent public-facing message for entities that haven't been published yet
// (tournaments, league cycles). Shown in place of the content so unpublished
// data isn't exposed.
defineProps({
  entity: {
    type: String,
    default: 'page'
  }
});
</script>

<template>
  <div class="tl-card np-notice">
    <div class="np-icon">
      <v-icon size="26" color="warning">mdi-eye-off-outline</v-icon>
    </div>
    <h2 class="np-title">Not published yet</h2>
    <p class="np-body">
      This {{ entity }} hasn’t been published yet, so it isn’t available to view. Check back once the
      organiser publishes it.
    </p>
  </div>
</template>

<style scoped lang="scss">
.np-notice {
  text-align: center;
  padding: 40px 24px;
}

.np-icon {
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: rgb(var(--v-theme-warningTint));
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
}

.np-title {
  font-size: 18px;
  font-weight: 800;
  letter-spacing: -0.4px;
}

.np-body {
  font-size: 13px;
  color: rgb(var(--v-theme-charcoal));
  margin: 8px auto 0;
  line-height: 1.7;
  max-width: 380px;
}
</style>
